import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RefreshLoaderComponent } from './refresh-loader.component';

@NgModule({
  declarations: [RefreshLoaderComponent],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports : [RefreshLoaderComponent]
})
export class RefreshLoaderModule { }
